import { Catalog } from "@cureskin/api-client/src/server-api";

export function getProductImage(product: Catalog): string | null {
  return product?.rebrandedImageWithBackground?.[0]
    ?? product?.productUnboxedImage?.[0]
    ?? null;
}

/**
 * Extract product images/video for slideshow.
 *
 * First image/video should be main product image then add extraImages
 *
 * @param product
 * @returns {type: 'video' | 'image', url: string}[]
 */
export function extractAssetsForSlider(product: any): { type: 'video' | 'image', url: string }[] {
  if (!product) return [];
  const assets: any[] = [];
  const { rebrandedImageWithBackground, extraImages }: any = product;

  if (rebrandedImageWithBackground?.length) {
    if (rebrandedImageWithBackground[0].split('.').pop() === 'mp4') {
      assets.push({ type: 'video', url: rebrandedImageWithBackground[0] });
    } else {
      assets.push({ type: 'image', url: rebrandedImageWithBackground[0] });
    }
  }

  const extraImagesFlat = extraImages?.flat()?.filter((url: string) => !!url);
  if (extraImagesFlat?.length) {
    extraImagesFlat.forEach((image: string): void => {
      if (image?.split('.')?.pop() === 'mp4') {
        assets.push({ type: 'video', url: image });
      } else {
        assets.push({ type: 'image', url: image });
      }
    });
  }
  return assets;
}

/**
 * Extract instruction video url in user's language based on user's status(paid/unpaid)
 *
 * @param product
 * @param user
 * @returns
 */
export function extractInstructionVideo(product: any, user: any): string | null {
  const userLanguage = user?.get('languagePreference') || 'en';
  // paid/unpaid instruction videos come directly on instructionSet in the getAllocatedRegimens payload
  const instructionSet = product?.instructionSet;
  if (!instructionSet) return null;

  // videoMap can be an empty object — resolve to a url before treating it as present
  const paidVideo = instructionSet.paidInstructionVideo?.[userLanguage] || instructionSet.paidInstructionVideo?.en;
  const unpaidVideo = instructionSet.unpaidInstructionVideo?.[userLanguage] || instructionSet.unpaidInstructionVideo?.en;
  if (user?.isPaid() && paidVideo) return paidVideo;
  return unpaidVideo || null;
}
